import {
  DEFAULT_ITEM_PER_PAGE,
  DEFAULT_PAGE_NUMBER,
} from 'components/registry/components/RegistryPagination/consts';
import { DefaultFindFnParams, EntryType, ProductType } from 'components/registry/types/api';

export const defaultParams: DefaultFindFnParams = {
  entryType: EntryType.registry,
  pageDetails: { itemsPerPage: DEFAULT_ITEM_PER_PAGE, pageNumber: DEFAULT_PAGE_NUMBER },
  productType: ProductType.feed,
  sortOrders: [{ field: 'fa_startValidityDate', asc: false, text: 'Дата регистрации добавки' }],
};

export const sortingOptions = [
  { field: 'fa_vendor', asc: false, text: 'Разработчик' },
  { field: 'rp_producerView', asc: false, text: 'Производитель' },
  { field: 'fa_name', asc: false, text: 'Название добавки' },
  { field: 'fa_purpose', asc: false, text: 'Назначение' },
  { field: 're_series', asc: false, text: 'Учётная серия №' },
  { field: 're_regNumber', asc: false, text: 'Регистрационный №' },
  { field: 'fa_form', asc: false, text: 'Форма выпуска' },
  { field: 'fa_startValidityDate', asc: false, text: 'Дата регистрации добавки' },
  { field: 're_registryStatusInRegistry', asc: false, text: 'Статус' },
];

export const excelFields = [
  {
    field: 'fa_name',
    text: 'Название добавки',
    enable: true,
  },
  {
    field: 'ph_vendor',
    text: 'Разработчик',
    enable: true,
  },
  {
    field: 'fa_vendorCountry',
    text: 'Страна разработчика',
    enable: true,
  },
  {
    field: 'fa_producers',
    text: 'Производители',
    enable: true,
  },
  {
    field: 'fa_producerCountry',
    text: 'Страна производителя',
    enable: true,
  },
  {
    field: 'fa_producerLocations',
    text: 'Площадки производителя',
    enable: true,
  },
  {
    field: 'fa_producerNameAndLocations',
    text: 'Производитель и площадки производства',
    enable: true,
  },
  {
    field: 'fa_feedAdditiveType',
    text: 'Тип кормовой добавки',
    enable: true,
  },
  {
    field: 'fa_feedAdditiveKind',
    text: 'Вид КД',
    enable: true,
  },
  {
    field: 'rp_animalSpeciesList',
    text: 'Вид животного',
    enable: true,
  },
  {
    field: 'fa_purpose',
    text: 'Область применения',
    enable: true,
  },
  {
    field: 'fa_GMOInfo',
    text: 'Сведения о ГМО',
    enable: true,
  },
  {
    field: 'fa_form',
    text: 'Форма выпуска',
    enable: true,
  },
  {
    field: 're_requestDate',
    text: 'Дата регистрации заявки',
    enable: true,
  },
  {
    field: 're_requestRegNumber',
    text: 'Номер заявления',
    enable: true,
  },
  {
    field: 're_requestRegDate',
    text: 'Дата регистрации заявления',
    enable: true,
  },
  {
    field: 're_requestMethod',
    text: 'Способ подачи заявления',
    enable: true,
  },
  {
    field: 'fa_series',
    text: 'Учетная серия',
    enable: true,
  },
  {
    field: 'fa_regNumber',
    text: 'Регистрационный номер',
    enable: true,
  },
  {
    field: 'gm_endValidityDate',
    text: 'Срок действия свидетельства',
    enable: true,
  },
  {
    field: 'fa_startValidityDate',
    text: 'Дата регистрации добавки',
    enable: true,
  },
  {
    field: 're_registryStatus',
    text: 'Статус',
    enable: true,
  },
  {
    field: 're_erulRegDate',
    text: 'Дата получения регистрационного номера ЕРУЛ',
    enable: true,
  },
  {
    field: 're_erulRegNumber',
    text: 'Регистрационный номер ЕРУЛ',
    enable: true,
  },
];

export const groupByField = {
  field: 'fa_producerNameAndLocations',
  text: 'Производитель и площадки производства',
  enable: true,
};
